import {Component, OnInit} from '@angular/core';
import {fuseAnimations} from '../../../../../core/animations';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {CheckModalComponent} from '../../../check-save-modal/check-modal';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { MarketplaceCategoryService } from '../../../../../core/services/marketplaceCategory.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'new-marketplace-category',
    templateUrl: './new-mar-cat.component.html',
    styleUrls: ['./new-mar-cat.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class NewMarCatComponent implements OnInit {
  name = '';
  marketplaceSubCategory: any = [{mpsId: 1}];
  returnBack;
  constructor(public toastr: ToastrService, public marketplaceCategoryService: MarketplaceCategoryService,
              public router: Router, public dialog: MatDialog, public snackBar: MatSnackBar,
              public translate: TranslateService, private spinner: NgxSpinnerService) {

  }

  ngOnInit() {
  }

  removeSubCat(subCatId) {
    let index = this.marketplaceSubCategory.findIndex(el => +el.mpsId === +subCatId);
    if (index !== -1) {
      this.marketplaceSubCategory.splice(index, 1);
      if (!this.marketplaceSubCategory.length) {
        this.marketplaceSubCategory.push({mpsId: 1});
      }
    }
  }

  addSubCat() {
    let lastId = this.marketplaceSubCategory[this.marketplaceSubCategory.length - 1].mpsId;
    this.marketplaceSubCategory.push({mpsId: + lastId + 1});
    setTimeout(() => {
      let input: any = document.getElementById(+ lastId + 1 + '_subcat');
      if (input) {
        input.focus();
      }
    }, 100);
  }

  addCategory() {
    this.spinner.show();
    for (let i = 0; i < this.marketplaceSubCategory.length; i++) {
      let input: any = document.getElementById(this.marketplaceSubCategory[i].mpsId + '_subcat');
      let value = '';
      if (input && input.value) {
        value = input.value;
      }
      this.marketplaceSubCategory[i].name = value;
    }
    if (!this.name) {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('marketplaces.enter_name');
      this.toastr.error(msg, title);
      this.spinner.hide();
      return;
    }
    let category = {
      name: this.name
    };
    return this.marketplaceCategoryService.addMarketplaceCategory(category).toPromise().then((res: any) => {
      if (res && res.id) {
        for (let i = 0; i < this.marketplaceSubCategory.length; i++) {
          if (this.marketplaceSubCategory[i].name) {
            this.marketplaceCategoryService.addMarketplaceSubCategory(
              {
                name: this.marketplaceSubCategory[i].name,
                marketplaceCategoryId: res.id
              }
            ).subscribe();
          }
        }

        this.returnBack = true;
        setTimeout(() => {
          let title = this.translate.instant('successfully');
          let msg = this.translate.instant('marketplaces.marketplace_category_created');
          this.toastr.success(msg, title);
          this.router.navigate([ './pages/settings/marketplaceCategory' ]);
          this.spinner.hide();
        }, 2000);
        return true;
      }
    });
  }

  canDeactivate (): Observable<boolean> | boolean {
    if (this.returnBack) {
      return true;
    } else {
      return this.goBack();
    }
  }

  goBack (): any {
    let dialogRef;
    let input: any = document.getElementById(this.marketplaceSubCategory[0].mpsId + '_subcat');
    if (this.name || (input && input.value)) {
      dialogRef = this.dialog.open(CheckModalComponent , {
        panelClass: 'unsave-form-dialog',
        width: '400px',
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {

          if (this.name) {
            return this.addCategory();
          } else {
            let msg = this.translate.instant('fill_req_field');
            this.snackBar.open(msg , '' , {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }
}
